import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { reducer } from './reducer';
import { initialState } from './WellnessPlan.context.types';
export var WellnessPlanContext = React.createContext({
    state: initialState,
    dispatchContext: function () { return null; },
});
var WellnessPlanProvider = function (_a) {
    var children = _a.children;
    var _b = React.useReducer(reducer, initialState), state = _b[0], dispatch = _b[1];
    var contextValue = useMemo(function () { return ({ state: state, dispatchContext: dispatch }); }, [
        state,
        dispatch,
    ]);
    return (_jsx(WellnessPlanContext.Provider, { value: contextValue, children: children }));
};
export default WellnessPlanProvider;
